import { FeatureFlagGuard } from '@/modules/shared/components/feature-flag-guard/FeatureFlagGuard'
import { CareHomePage } from './pages/care-home/CareHome.page'
import { CareProgramDetail } from './pages/care-program/CareProgramDetail'
import { CareProgramEnrollForm } from './pages/care-program-enroll-form/CareProgramEnrollForm'
import { CareProgramPaymentStatus } from './pages/care-program-payment-status/CareProgramPaymentStatus'
import { CareRoot } from './pages/care-root/CareRoot.page'

import type { RouteObject } from 'react-router-dom'

const careRoutes: RouteObject[] = [
  {
    path: 'care',
    element: <FeatureFlagGuard flag='care_question' />,
    children: [
      {
        path: '',
        element: <CareRoot />,
        children: [
          {
            path: '',
            element: <CareHomePage />,
          },
          {
            path: 'care-program/:id',
            element: <CareProgramDetail />,
          },
          {
            path: 'payment-status/:paymentId',
            element: <CareProgramPaymentStatus />,
          },
          {
            path: 'enroll-form',
            element: <CareProgramEnrollForm />,
          },
        ],
      },
    ],
  },
]

export { careRoutes }
